<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
      customStatusReady: false,
      basketReady: false,
      originalDataLayerPush: null
    }
  },

  mounted() {
    this.mountedInit()
  },

  beforeDestroy() {
    if (this.originalDataLayerPush && window.dataLayer) {
      window.dataLayer.push = this.originalDataLayerPush
    }
    if (this._unwatchBasketReady) this._unwatchBasketReady()
  },

  methods: {
    mountedInit() {
      console.error('consentStatusCheckoutCart mountedInit called')
      if (!window) return

      // If already handled, trigger immediately
      if (window.__consentStatus) {
        console.error('consent_status already set:', window.__consentStatus)
        this.customStatusReady = true
        this.checkAndTrigger()
        return
      }

      // Ensure dataLayer exists
      if (!window.dataLayer) {
        window.dataLayer = []
      }

      // Check existing entries
      for (const item of window.dataLayer) {
        if (item?.event === 'consent_status') {
          console.error('consent_status found in existing dataLayer:', item)
          window.__consentStatus = item
          this.customStatusReady = true
          this.checkAndTrigger()
          return
        }
      }

      // Intercept future pushes
      this.originalDataLayerPush = window.dataLayer.push

      const self = this
      window.dataLayer.push = function(...args) {
        for (const arg of args) {
          if (arg?.event === 'consent_status') {
            console.error('consent_status intercepted via dataLayer.push:', arg)
            window.__consentStatus = arg
            const r = self.originalDataLayerPush.apply(this, args)
            self.customStatusReady = true
            self.checkAndTrigger()
            return r
          }
        }
        return self.originalDataLayerPush.apply(this, args)
      }

      // Listen for Nuxt event
      this._unwatchBasketReady = this.$nuxt.$on('BASKET_READY_CONSENT_STATUS', () => {
        console.error('BASKET_READY_CONSENT_STATUS received')
        this.basketReady = true
        this.checkAndTrigger()
      })

      // this.$store.getters['UI/debug'] &&
      //   setTimeout(() => {
      //     // Trigger the consent_status event after 4 second
      //     console.error('(MIXINS) Triggering consent_status...')
      //     window.dataLayer.push({
      //       event: 'consent_status',
      //       consent_status: {
      //         ad_storage: 'granted',
      //         analytics_storage: 'granted',
      //         wait_for_update: 5000
      //       }
      //     })
      //     console.error('(MIXINS) consent_status triggered!')
      //   }, 10)
    },
    checkAndTrigger() {
      console.log(`checkAndTrigger customStatusReady=${this.customStatusReady} basketReady=${this.basketReady}`)
      if (this.customStatusReady && this.basketReady) {
        console.log(`checkAndTrigger: both conditions met`)
        this.triggerViewCart()
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
